import React, { useId } from 'react';
import { Book, Edit3, BookOpen, PenTool, Mic, ChevronRight, CheckCircle2 } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';

export const PRACTICE_SUBJECTS = [
  { id: 'vocab', Icon: Book, iconStyle: 'bg-sky-100 text-sky-600', border: 'hover:border-sky-300' },
  { id: 'grammar', Icon: Edit3, iconStyle: 'bg-indigo-100 text-indigo-600', border: 'hover:border-indigo-300' },
  { id: 'reading', Icon: BookOpen, iconStyle: 'bg-teal-100 text-teal-600', border: 'hover:border-teal-300' },
  { id: 'writing', Icon: PenTool, iconStyle: 'bg-purple-100 text-purple-600', border: 'hover:border-purple-300' },
  { id: 'speaking', Icon: Mic, iconStyle: 'bg-rose-100 text-rose-600', border: 'hover:border-rose-300' },
];
export const isPracticeSubject = view => PRACTICE_SUBJECTS.some(subject => subject.id === view);

export const PracticeCards = () => {
  const { t, setView, getDailyStatus } = useAppContext();
  const idPrefix = useId();
  return <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 sm:gap-4">
    {PRACTICE_SUBJECTS.map(({ id, Icon, iconStyle, border }) => {
      const done = getDailyStatus(id).isComplete;
      return <button key={id} type="button" aria-label={t(`nav_${id}`)} onClick={() => setView(id)}
        aria-describedby={`${idPrefix}-${id}-description${done ? ` ${idPrefix}-${id}-done` : ''}`}
        className={`practice-card practice-card--${id} learning-link flex flex-col items-start min-w-0 rounded-2xl border p-5 text-left transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${done ? 'practice-card--done' : `border-slate-200 bg-white ${border}`}`}>
        <span className="flex w-full items-center gap-2">
          <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${iconStyle}`}><Icon size={19} aria-hidden="true" /></span>
          <span className="flex min-w-0 flex-1 flex-wrap items-center gap-x-2 gap-y-1.5">
            <span className="text-base font-semibold text-slate-800 break-words">{t(`nav_${id}`)}</span>
            {done && <span id={`${idPrefix}-${id}-done`} className="practice-daily-done inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-2 py-1 text-xs font-semibold"><CheckCircle2 size={12} aria-hidden="true" />{t('practice_daily_done')}</span>}
          </span>
          <ChevronRight size={18} aria-hidden="true" className="shrink-0 text-slate-400" />
        </span>
        <span id={`${idPrefix}-${id}-description`} className="mt-3 block text-sm leading-relaxed text-slate-500">{t(`module_${id}_desc`)}</span>
      </button>;
    })}
  </div>;
};
